export const LINEAGE_GRAPH = 'attribute-lineage-graph';
